const WingWorkAppBarLogo = ({ visible }: { visible: boolean }) => {
  return (
    <img
      src="/WingWorkFullLogo.png"
      alt="Wingwork Logo"
      width={'180px'}
      className={`
    absolute h-5 transition-all duration-300 ease-in-out
    ${visible ? 'translate-x-0 opacity-100' : '-translate-x-4 opacity-0'}
  `}
    />
  )
}

export default WingWorkAppBarLogo
